import React from 'react';
import styled from 'styled-components';

/**
 * DeviceSettings component that displays a frame with a URL constructed from props
 * @param {Object} props - Component props
 * @param {string} props.lane - Lane parameter for the URL
 * @param {string} props.server - Server parameter for the URL
 * @returns {JSX.Element} - Rendered component
 */

const DeviceSettingsContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
`;
const DeviceSettings = ({ lane, server, setDeviceSettings }) => {
  // Construct the URL using the lane and server props
  const url = `http://10.1.1.10:25000/?lane=${lane}&server=${server}`;

  return (
    <DeviceSettingsContainer onClick={() => setDeviceSettings(null)}>
      <iframe
        style={{
          width: "100%",
          height: "95%",
          border: "none",
          allowFullScreen: true,
        }}
        src={url}
        title="Device Settings"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    </DeviceSettingsContainer>
  );
};

export default DeviceSettings;
